import { TDevice } from '@cian/utils';
import { ESiteType } from '../../types/analytics';

export const SITE_TYPE_MAP: { [key: string]: ESiteType } = {
  desktop: ESiteType.Desktop,
  tablet: ESiteType.Tablet,
  phone: ESiteType.Mobile,
};

export function getSiteType(device: TDevice): ESiteType {
  return SITE_TYPE_MAP[device];
}
